import { Row } from "reactstrap";
import { Exitbtn } from "../../components/buttons/exitbtn";
import {
  exerciseType,
} from "../../components/constants/constants";
import { Sendtaskbtn } from "../../components/buttons/sendTask";
import PrintScreenButton from "../../components/buttons/PrintButton";
import FeedbackButton from "../../components/buttons/AddFeedbackButton";

export const GPT4BottomButtonPannel = ({
  getStudentid,
  student_level,
  exercise_page_no,
  exercise_id,
  isReview,
  book_id,
  ex_b_c,
  baseUrl,
  data,
  exercise_page_number,
  show_exercises,
  search,
  st_c_t_c,
  st_th_c,
  st_gr_c,
  st_fn_c,
  st_le_c,
  isSubmitting,
  get_tab,
  homework_tab_query_string,
  content_type,
  redirect,
  setClearanswers,
  GradingToggle,
  GradeWithAI,
  IsFeedbackGenerating,
  ReportToggle
}) => {
  let href = null;
  let showExitButton = false;
  let query_string;
  if (redirect === "templates") {
    query_string = `e-p-n=${exercise_page_number}&s-e=${show_exercises}&reset=false`;
    if (search) {
      query_string = `${query_string}&search=${search}`;
    }
    if (st_c_t_c) {
      query_string = `${query_string}&st_c_t_c=${st_c_t_c}`;
    }
    if (st_le_c) {
      query_string = `${query_string}&st_le_c=${st_le_c}`;
    }
    if (ex_b_c) {
      query_string = `${query_string}&ex_b_c=${ex_b_c}`;
    }
    if (st_th_c) {
      query_string = `${query_string}&st_th_c=${st_th_c}`;
    }
    if (st_fn_c) {
      query_string = `${query_string}&st_fn_c=${st_fn_c}`;
    }
    if (st_gr_c) {
      query_string = `${query_string}&st_gr_c=${st_gr_c}`;
    }
    if (content_type) {
      query_string = `${query_string}&type=${content_type}`;
    }
  }  else if (redirect === "status") {
    if (get_tab) {
      href = `${baseUrl}/a/status?${homework_tab_query_string}`;
      showExitButton = true;
    }
  }

  return (
    <div className="no-download">
      {data.task_type === exerciseType.PRONUNCIATION_TASK ||
      data.task_type === exerciseType.SPEAKING_TASK ? (
        <Row>
          {/* {edit_template !== "true" && ( */}
            <div className="col-12 d-inline-flex  d-flex justify-content-end">
              <PrintScreenButton px_class={"px-4 me-3"} downloadUrl={`/pdf/download/${data.id}`} />
            </div>
          {/* )} */}
        </Row>
      ):(
        <Row>
          <div className="col-6">
            {showExitButton ? (
              <Exitbtn href={href} />
            ): data && data.task_type === exerciseType.WRITING_TASK ? (
              <FeedbackButton GradingToggle={ReportToggle} feedback_label="Sample report" />
            ):(
              <div>
                {data && data?.ai_grading_task && data?.questions && data?.questions?.[0]?.type === "FillInBlank" ? (
                  <>
                    {data?.ai_marking_scheme ? (
                      <>
                      <FeedbackButton isSubmitting={isSubmitting} isReview={isReview} setClearanswers={setClearanswers} checklabel={GradeWithAI ? "Checking with AI" : "Checking"}  label="See answers" />
                      </>
                    ): IsFeedbackGenerating ? (
                      <>
                      <FeedbackButton GradingToggle={GradingToggle} IsFeedbackGenerating={IsFeedbackGenerating} feedback_label="Adding AI grades" />
                      </>
                    ):(
                      <>
                        <FeedbackButton isSubmitting={isSubmitting} isReview={isReview} setClearanswers={setClearanswers} GradingToggle={GradingToggle} feedback_label="See answers" />
                        {/* <CheckButton isSubmitting={isSubmitting} isReview={isReview} setClearanswers={setClearanswers} label="Check answers" /> */}
                      </>
                    )}
                  </>
                ): data && data?.questions && data?.questions?.[0]?.ai_feedback ? (
                  <>
                    <FeedbackButton isSubmitting={isSubmitting} isReview={isReview} setClearanswers={setClearanswers} checklabel={"Checking with AI"} label="See answers" />
                  </>
                ): IsFeedbackGenerating ? (
                  <>
                    <FeedbackButton GradingToggle={GradingToggle} IsFeedbackGenerating={IsFeedbackGenerating} feedback_label="Adding AI feedback" />
                  </>
                ):(
                  <>
                    <FeedbackButton isSubmitting={isSubmitting} isReview={isReview} setClearanswers={setClearanswers} GradingToggle={GradingToggle} feedback_label="See answers" />
                    {/* <CheckButton isSubmitting={isSubmitting} isReview={isReview} setClearanswers={setClearanswers} label="Check answers" /> */}
                  </>
                )}
              </div>
            )}
          </div>
          {/* {edit_template !== "true" && ( */}
            <div className="col-6 d-inline-flex text-nowrap  d-flex justify-content-end">
              <div>
                <PrintScreenButton px_class={"px-4 me-3"} downloadUrl={`/pdf/download/${data.id}`} exercise_id={data?.id} audiourl={data.audio} />
                {redirect === "templates" ? (
                  <Sendtaskbtn
                  href="#"
                  data-bs-toggle="modal"
                  label="Assign this task"
                  data-bs-target={`#exercise${data.id}`}
                  exercise_id={data.id? data.id : 1}
                  />
                ) : (
                  <Sendtaskbtn
                    href="#"
                    data-bs-toggle="modal"
                    label="Assign this task"
                    data-bs-target={`#exercise${data.id}`}
                    exercise_id={data.id? data.id : 1}
                  />
                )}
              </div>
            </div>
          {/* )} */}
        </Row>
      )}
    </div>
  );
};
